import { Userstory } from './userstory';

export class Sprint {

  public id: number;
  public name: string;
  public startDate: string;
  public endDate: string;
  public originBoardId: number;
  public self: string;
  /**
   * This holds strings that are specific to Jira. Should be generalized with our own enum
   * and mapping to/from jira.
   */
  public state: string;
  public projectId: number;
  // This is only used by releasplanning to hold the sprints issues and should be removed
  // hold issues in a map in the componenent instead
  public stories: Userstory[];

  constructor(id: number, name: string, startDate: string, endDate: string, state: string) {
    this.id = id;
    this.name = name;
    this.startDate = startDate;
    this.endDate = endDate;
    this.state = state;
  }

  public static getCopy(sprint: Sprint): Sprint {
    const copy: Sprint = new Sprint(sprint.id, sprint.name, sprint.startDate, sprint.endDate, sprint.state);
    copy.projectId = sprint.projectId;
    copy.stories = sprint.stories;
    return copy;
  }
}


